import React from 'react';
import videojs from 'video.js';

// Simple wrapper for video.js library
// Modified version of the code here https://docs.videojs.com/tutorial-react.html

import './styles/VideoJS.scss';

export default class VideoPlayer extends React.Component<videojs.PlayerOptions> {
  wrapperNode: HTMLDivElement | null = null;
  videoNode: HTMLVideoElement | null = null;
  player: videojs.Player | null = null;

  state = {
    readyToLoad: false,
    errorScreen: false,

    // Videojs mangles some of the html we provide for it, so when we reload it,
    // increment this key to let react know to make new components
    key: 1,
  };

  componentDidMount() {
    // instantiate Video.js
    this.resetPlayer();
  }

  componentDidUpdate() {
    if (this.state.readyToLoad && this.videoNode) {
      this.player = videojs(this.videoNode, this.props);
      this.player.on('error', this.handleError);

      this.player.on('ended', this.resetPlayer);
      this.setState({
        readyToLoad: false,
        errorScreen: false,
      });
    }
  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  handleError = (e: Event) => {
    e.stopImmediatePropagation();

    if (this.wrapperNode) {
      // Manually override this dialog's text
      // This is done because the built-in way to override this is to override
      // the english translation. We don't currently support any translations, so
      // it makes more sense to bypass this so it's not overlooked when we
      // eventually add translations one day.
      const dialog = this.wrapperNode.querySelector('.vjs-error-display .vjs-modal-dialog-content');
      if (dialog) {
        dialog.innerHTML = `
          <p>Error loading video</p>
          <p><b>Click to retry</b></p>
        `;
      }
    }
    this.setState({
      errorScreen: true,
    });
  };

  handleClick = () => {
    if (this.state.errorScreen) {
      this.resetPlayer();
    }
  };

  resetPlayer = () => {
    if (this.player) {
      this.player.dispose();
    }

    this.setState({
      readyToLoad: true,
      errorScreen: false,
      key: this.state.key + 1,
    });
  };

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render() {
    return (
      <div
        key={this.state.key}
        className="videojs-wrapper-wrapper"
        ref={(node) => (this.wrapperNode = node)}
        onClick={this.handleClick}
      >
        <div data-vjs-player className="videojs-wrapper">
          <video
            ref={(node) => (this.videoNode = node)}
            className="video-js vjs-default-skin vjs-big-play-centered vjs-fill"
          />
        </div>
      </div>
    );
  }
}
